import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';
import { generateDoubleBooking } from '../CallsheetUtils';

class NumberOfSetDoubleBookRow extends Component {
  render() {
    const { info } = this.props;
    const doubleBookingInfo = generateDoubleBooking(info);

    return (
      <>
        <tr>
          <th colSpan="2" style={styles.tableCell}>
            {i18n.t('location:numberOfSet')}
          </th>
          <th colSpan="2" style={styles.tableCell}>
            {i18n.t('location:doubleBooking')}
          </th>
        </tr>
        <tr>
          <td colSpan="2" style={styles.tableCell}>
            {i18n.t(`location:${info.numberOfSet}`)}
          </td>
          <td colSpan="2" style={styles.tableCell}>
            {doubleBookingInfo.length ? doubleBookingInfo : i18n.t('none')}
          </td>
        </tr>
      </>
    )
  }
}

NumberOfSetDoubleBookRow.propTypes = {
  info: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
      PropTypes.number,
      PropTypes.array,
      PropTypes.object,
    ])
  ).isRequired,
}

export default NumberOfSetDoubleBookRow;
